import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { formatDate } from '@/lib/format'

interface PostMetaProps {
    publishedAt: string
    readMinutes: number
    className?: string
}

export const PostMeta: FC<PostMetaProps> = ({
    publishedAt,
    readMinutes,
    className
}): ReactNode => {
    return (
        <div
            className={cn(
                'flex flex-wrap items-center gap-x-2 gap-y-1 text-sm text-muted-foreground',
                className
            )}
        >
            <time dateTime={publishedAt}>
                {formatDate(publishedAt)}
            </time>

            <span aria-hidden='true'>·</span>
            <span>
                {readMinutes} min read
            </span>
        </div>
    )
}
